import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'
import Intro from './routes/Intro'
import Question from './routes/Question'
import Finish from './routes/Finish'

export default (store) => ({
  path: 'decision-tool',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const DecisionTool = require('./containers/DecisionToolContainer').default
      const reducer = require('./modules/reducer').default
      const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'decisionTool'  */
      injectReducer(store, { key: 'decisionTool', reducer })
      injectSagas(store, { key: 'decisionTool', sagas })

      /*  Return getComponent   */
      cb(null, DecisionTool)

    /* Webpack named bundle   */
    }, 'DecisionTool')
  },

  indexRoute: { onEnter: (nextState, replace) => replace('/decision-tool/intro') },

  childRoutes: [
    Intro(store),
    Question(store),
    Finish(store)
  ]
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/DecisionTool/index.js
 **/